export default {
  methods: {
    async logoutFromApplication() {
      this.$loader.show(this.$routerPlugin.logoutFromApplication())
    },
  },
}
